import axios from 'axios';
export var postBRRequest = function postBRRequest(path, body, config) {
  if (config === void 0) {
    config = {};
  }

  return axios.post("" + process.env.GATSBY_BR_PREAPPROVAL_URL + path, body, config);
};